import script from "./ResellerCustomerBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ResellerCustomerBanner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ResellerBanner from "@/components/ResellerBanner.vue";
script.components = Object.assign({}, { ResellerBanner }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ResellerBanner }, script.__o.components);}